const filterButton = () => {

  const $pfButton = $('.post-filter-button button');
        
  
  if ($pfButton) {
    
    const $pfExpand = $pfButton.next('.category-expand'),
          $pfParent = $pfButton.parent();
    
    $pfButton.on('click', function () {
      $pfParent.add($pfExpand).toggleClass('active');
    });
    
  }

}

export {
  filterButton
};